import React from "react";
import { Box, Typography } from "@mui/material";

import { PieChart, Pie } from "recharts";

interface IProps {
  title: string;
  succeed: number;
  failed: number;
}

const OverallSales = ({ title, succeed, failed }: IProps): JSX.Element => {
  const data02 = [
    { name: "A1", value: succeed, fill: "#39d29f" },
    { name: "A2", value: failed },
  ];

  return (
    <Box>
      <Typography fontSize="20px" fontWeight="600">
        {title}
      </Typography>

      <Box display="flex" alignItems="center">
        <PieChart width={350} height={350}>
          <Pie
            data={data02}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            fill="#F9B03C"
            label
          />
        </PieChart>
        <Box>
          <Box
            sx={{
              paddingLeft: 6,
              position: "relative",
              ":before": {
                content: '""',
                width: 20,
                height: 20,
                display: "block",
                position: "absolute",
                bgcolor: "#39d29f",
                borderRadius: "50%",
                left: 0,
              },
            }}
          >
            Успешные заказы - {succeed}
          </Box>
          <Box
            sx={{
              paddingLeft: 6,
              position: "relative",
              ":before": {
                content: '""',
                width: 20,
                height: 20,
                display: "block",
                position: "absolute",
                bgcolor: "#F9B03C",
                borderRadius: "50%",
                left: 0,
              },
            }}
          >
            Отмены - {failed}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { OverallSales };
